<script lang="ts">
  import { onMount, setContext } from "svelte"
  import Navigation from "./Navigation.svelte"
  import PrevNextSkipButtons from "$app/Pages/Plans/Onboarding/components/PrevNextSkipButtons.svelte"
  import img from "@images/onboarding/one_page_overview.jpg"
  import { onboardingStore } from "./onboarding.svelte"

  onboardingStore.completed = true

  onMount(() => {
    onboardingStore.setBrowserHistory({}, "overview")
  })
</script>

<div class="mx-auto px-2 lg:px-6 pt-4 w-full pb-8 lg:pb-20 lg:text-left">
  <div class="px-4 w-full">
    <Navigation step={onboardingStore.current_onboarding_step} on:updateStep />

    <div class="px-4 w-full lg:w-1/2 xl:pr-16">
      <h2 class="mt-12 text-5xl font-bold text-center text-white">
        One Page View Setup
      </h2>
      <h3 class="mt-4 text-2xl text-white mb-8">
        The next series of steps will walk you through the setup of your One
        Page View.
      </h3>

      <p class="mt-8 text-white text-2xl">
        The One Page View is the foundation of your Lead With Purpose plan and
        one that should be developed with care and thoughtfulness in
        consultation with your team.
      </p>
      <p class="mt-8 text-white text-xl">
        To help you on your journey we highly recommend our online course
        <span class="font-bold">E1: One-Page Alignment Plan</span>. Upon
        purchase this course is available for you and any team members you add.
      </p>
      <p class="mt-8 text-white text-xl">
        If you prefer to manually set up your plan, click the "Skip Onboarding"
        button to go directly to your plan's One Page View. If you want to
        schedule a call with our team to help you on this journey, please click
        "I need help".
      </p>

      <PrevNextSkipButtons />
    </div>
  </div>
</div>

<div
  class="relative w-full hidden lg:inline lg:absolute lg:inset-y-32 lg:-mb-32 rounded-tl-lg lg:-right-0 md:w-1/3 lg:w-1/2 bg-lwp-light-grey bg-no-repeat bg-cover bg-left-top"
  style="background-image: url({img})"
></div>
